<template>
    <div class="contaniner">
        <banner :type="type" :poster="poster"></banner>
        <div class="news-page-box">
            <Ptitle :chineseTitle="title.chineseTitle" :enTitle="title.enTitle"></Ptitle>
            <div class="content-box">
                <step :stepLeftImg='require("../../assets/images/step01.png")' stepLeftTitle="入驻前准备"
                    stepRightTopText="了解信息"
                    stepRightBottom="入驻商户的经营（生产）地址和仓库地址应当与经营（生产）许可证或备案地址相同。企业的网络管理模式应与营业执照或备案业务相同。" type="long"
                    :processConfig="processConfig">

                </step>

                <step v-for="item in stepConfig" :stepLeftImg=item.stepLeftImg :stepLeftTitle="item.stepLeftTitle"
                    :stepRightTopText="item.stepRightTopText" :stepRightBottom="item.stepRightBottom" :key="item">
                </step>

                <step :stepLeftImg='require("../../assets/images/step04.png")' stepLeftTitle="店铺上线"
                    stepRightTopText="商品上架" stepRightBottom="发布商品及店铺上线，完成入驻。" end="true">

                </step>
            </div>
            <!-- <div style="margin-top: 60px">
              <friends-box></friends-box>
            </div> -->
        </div>
        <msg-box></msg-box>
        <top-arrow></top-arrow>
        <moni-footer></moni-footer>
    </div>
</template>

<script>
import banner from "../../components/banner/banner";
import Ptitle from "../../components/header/processTitle";
import step from "../../components/step/step"
import msgBox from "../../components/msgBox/msgBox";
import friendsBox from "../../components/friendsBox/friendsBox";
import topArrow from "../../components/topArrow/topArrow";
import moniFooter from "../../components/moniFooter/moniFooter";

export default {
    nama: "merchantEntry",
    data() {
        return {
            type: "poster",
            poster: require("../../assets/images/entry_top.png"),
            title: {
                chineseTitle: "入驻流程",
                enTitle: "ENTRY PROCESS",
            },
            stepConfig: [
                {
                    stepLeftImg: require("../../assets/images/step02.png"),
                    stepLeftTitle: "等待审核",
                    stepRightTopText: "资质审核",
                    stepRightBottom: `<div>1、所有资质均真实有效且正规，勿采用电子章；</div>
                                    <div>2、授权链路完整且有效。</div>`
                },
                {
                    stepLeftImg: require("../../assets/images/step03.png"),
                    stepLeftTitle: "完善商品信息",
                    stepRightTopText: "商品审核",
                    stepRightBottom: `审核通过后，完善商品资料，商品审核完成后安排上架。`
                },
            ],
            processConfig: [
                {
                    processRightTopText: "准备资料",
                    processRightBottom: `<div>1、医疗器械生产（经营）许可证；</div>
                                        <div>2、医疗器械网络销售备案；</div>
                                        <div>3、备案凭证编号；</div>
                                        <div>4、如入驻资料缺少或有误，会退回给您重新提交，建议您事先根据要求准备齐全，一次性通过审核。</div>
                                        `
                },
                {
                    processRightTopText: "提交入驻资料",
                    processRightBottom: `<div>1、查看<a 
                                                style="color: #05A2E1; cursor: pointer; text-decoration:underline"
                                                href="./static/download/merchantSettlement.docx" 
                                                target="downloadFile"
                                                download="默尼-商户入驻资料"
                                                >
                                                <iframe style="display: none;" name="downloadFile"></iframe>
                                                入驻所需资料
                                                </a>，下载并按要求填写发送至邮箱 service@gzmoninet.com 。</div>
                                        <div> 邮件格式为  收件人：邮箱 ；主题：企业名称+申请入驻 （如 默尼申请入驻）；上传入驻资料附件</div>
                                        <div>2、如入驻资料缺少或有误,会影响审核结果，建议您事先根据要求准备齐全，一次性通过审核。<div>
                                        `
                }
            ]
        }
    },
    components: {
        banner,
        Ptitle,
        step,
        moniFooter,
        msgBox,
        topArrow,
        friendsBox
    },
    methods: {
    }
}
</script>

<style lang="scss" scoped>
.contaniner {
    .news-page-box {
        width: 100%;
        min-height: 1550px;
        padding: 90px 200px 185px 200px;
        box-sizing: border-box;
        font-size: 20px;
        position: relative;
        background-image: url("../../assets/images/entry_contaniner_2.png");
        // background-image: url("../../assets/images/entry_contaniner.png");
        background-size: 100% 100%;
        background-repeat: no-repeat;

        .content-box {
            margin-top: 60px;
            background-color: #fff;
            box-shadow: 0px 0px 31px 0px rgba(0, 109, 152, 0.05);
            padding: 70px 103px;

            .step-box {
                display: flex;
                justify-content: space-between;

                .step_left {
                    width: 105px;
                    margin-right: 90px;

                    .step_left_img {
                        width: 80px;
                        height: 80px;
                        margin: auto;

                        >img {
                            height: 100%;
                            width: 100%;
                        }
                    }

                    .step_left_title {
                        font-size: 20px;
                        font-weight: bold;
                        color: #05A2E1;
                        line-height: 26px;
                    }
                }

                .step_right {
                    width: 85%;

                    .step_right_top {
                        background-color: hsla(197, 96%, 45%, 0.2);
                        height: 60px;
                        width: 100%;
                        padding-left: 20px;
                        margin-bottom: 16px;
                        box-sizing: border-box;
                        text-align: left;
                        display: flex;
                        align-items: center;

                        .step_right_top_img {
                            height: 20px;
                            width: 20px;

                            >img {
                                height: 100%;
                                width: 100%;
                            }
                        }

                        .step_right_top_text {
                            font-size: 20px;
                            font-weight: bold;
                            color: #222222;
                            line-height: 26px;
                        }
                    }

                    .step_right_bottom {
                        font-size: 16px;
                        color: #666666;
                        line-height: 31px;
                        text-align: left;
                        text-indent: 2em;
                    }
                }
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/merchantEntry/merchantEntry.vue